import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-139e384e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "document bg-white relative grid grid-cols-3 gap-6" }
const _hoisted_2 = { class: "title-section-spacing sticky top-0 bg-white z-20" }
const _hoisted_3 = { class: "grid grid-cols-2 pt-6" }
const _hoisted_4 = { class: "font-bold block text-left pb-4" }
const _hoisted_5 = { class: "messages relative rounded-xl" }
const _hoisted_6 = { class: "chat-box relative w-full bg-gray-50 rounded-xl" }
const _hoisted_7 = {
  class: "messages w-full overflow-y-auto p-8",
  ref: "messagesContainer"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Carica altri", -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "document-message"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 1,
  class: "img-message w-48 h-auto"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "message text-left text-lg" }
const _hoisted_16 = { class: "time-and-checks flex items-center justify-end" }
const _hoisted_17 = { class: "time text-xs text-primary-100" }
const _hoisted_18 = { class: "inputs absolute bottom-8 m-auto w-full" }
const _hoisted_19 = { class: "mx-8" }
const _hoisted_20 = {
  key: 0,
  class: "inputs-section flex items-end w-full"
}
const _hoisted_21 = { class: "left w-full" }
const _hoisted_22 = {
  key: 0,
  class: "attachment bg-white rounded-t-xl p-3"
}
const _hoisted_23 = {
  key: 0,
  class: "document-attachment"
}
const _hoisted_24 = { class: "flex items-center justify-between" }
const _hoisted_25 = { class: "left flex items-center" }
const _hoisted_26 = { class: "pl-2 text-xs text-primary-200" }
const _hoisted_27 = { class: "right" }
const _hoisted_28 = {
  key: 1,
  class: "photo"
}
const _hoisted_29 = { class: "flex items-center justify-between" }
const _hoisted_30 = { class: "left flex items-center" }
const _hoisted_31 = { class: "pl-2 text-xs text-primary-200" }
const _hoisted_32 = { class: "right" }
const _hoisted_33 = { class: "flex items-center w-fit" }
const _hoisted_34 = {
  key: 0,
  class: "tooltip-actions absolute bottom-8 right-2"
}
const _hoisted_35 = ["accept"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image pl-1" }, "Foto", -1))
const _hoisted_37 = ["accept"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image pl-1" }, "File", -1))
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "details p-6" }
const _hoisted_41 = { class: "chat-details text-primary-600 font-bold text-xl" }
const _hoisted_42 = { class: "created text-xs" }
const _hoisted_43 = { class: "users-in-the-chat pt-8" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Partecipanti:", -1))
const _hoisted_45 = { class: "chat-users-list text-left cursor-pointer truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.chat != undefined)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["body", _ctx.showChatDetails == true ? 'col-span-2' : 'col-span-3' ])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(["col-span-1 title-row cursor-pointer w-full flex items-center", _ctx.chat.pinnedMessage ? 'col-span-1' : 'col-span-2' ]),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showChatDetailsOnClick && _ctx.showChatDetailsOnClick(...args)))
              }, [
                _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.chat.name), 1)
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (!_ctx.paginationCompleted)
                  ? (_openBlock(), _createBlock(_component_SecondaryButton, {
                      key: 0,
                      onClick: _ctx.paginateMessages
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isLoading)
                          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              key: 0,
                              class: "animate-spin text-black h-4 mr-4",
                              icon: ['fas', 'circle-notch']
                            }))
                          : _createCommentVNode("", true),
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "message-cloud pb-3",
                    ref_for: true,
                    ref: `message#${message.id}`
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["bubble h-min-20 bg-white p-4 shadow-md relative", _ctx.isMessageCreator(message)  ? 'border-r-4 border-primary-600 rounded-l-lg ml-auto' : 'border-l-4 border-secondary-600 rounded-r-lg' ])
                    }, [
                      (!_ctx.isMessageCreator(message))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "user-name text-left font-bold text-base text-primary-400 cursor-pointer hover:text-primary-200",
                            onClick: ($event: any) => (_ctx.$router.push(`/users/${message.createdByUserId}`))
                          }, _toDisplayString(_ctx.getUserDisplayName(message.createdByUserId)), 9, _hoisted_9))
                        : _createCommentVNode("", true),
                      (message.attachmentUrl)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["attachment flex", _ctx.isMessageCreator(message) ? 'justify-end' : 'justify-start'])
                          }, [
                            (message.type == 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  _createElementVNode("a", {
                                    class: "cursor-pointer group",
                                    href: message.attachmentUrl,
                                    target: "_blank"
                                  }, [
                                    _createVNode(_component_font_awesome_icon, {
                                      class: "h-12 w-12 text-primary-400 group-hover:opacity-75",
                                      icon: ['fas', 'file-lines']
                                    })
                                  ], 8, _hoisted_11)
                                ]))
                              : (message.type == 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("a", {
                                      class: "cursor-pointer group",
                                      href: message.attachmentUrl,
                                      target: "_blank"
                                    }, [
                                      _createElementVNode("img", {
                                        class: "rounded-lg group-hover:opacity-75",
                                        src: message.attachmentUrl
                                      }, null, 8, _hoisted_14)
                                    ], 8, _hoisted_13)
                                  ]))
                                : _createCommentVNode("", true)
                          ], 2))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(message.text), 1),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.moment(message.createdTs).format('DD/MM/YYYY HH:mm')), 1)
                      ])
                    ], 2)
                  ], 512))
                }), 256))
              ], 512),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  (_ctx.isUserAChatParticipant)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          (_ctx.uploadingFile)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                (_ctx.mimeTypeSlag == 'PDF' || _ctx.mimeTypeSlag == 'FILE')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                      _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("div", _hoisted_25, [
                                          _createVNode(_component_font_awesome_icon, {
                                            class: "h-5 w-5 text-primary-400",
                                            icon: ['fas', 'file']
                                          }),
                                          _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.loadedFileName), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_27, [
                                          _createVNode(_component_font_awesome_icon, {
                                            class: "h-5 w-5 text-primary-400 cursor-pointer z-20",
                                            icon: ['fas', 'xmark'],
                                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.newFile = undefined, _ctx.uploadingFile = undefined))
                                          })
                                        ])
                                      ])
                                    ]))
                                  : (_ctx.mimeTypeSlag == 'PNG' || _ctx.mimeTypeSlag == 'JPG')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                        _createElementVNode("div", _hoisted_29, [
                                          _createElementVNode("div", _hoisted_30, [
                                            _createVNode(_component_font_awesome_icon, {
                                              class: "h-5 w-5 text-primary-400",
                                              icon: ['fas', 'image']
                                            }),
                                            _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.loadedFileName), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_32, [
                                            _createVNode(_component_font_awesome_icon, {
                                              class: "h-5 w-5 text-primary-400 cursor-pointer z-20",
                                              icon: ['fas', 'xmark'],
                                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.newFile = undefined, _ctx.uploadingFile = undefined))
                                            })
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["bg-white py-4 shadow-lg flex items-center w-full", _ctx.uploadingFile ? 'rounded-b-xl' : 'rounded-xl'])
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "w-full mx-6 outline-0 aspect-none outline-none",
                                type: "text",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.message) = $event)),
                                placeholder: "Scrivi un messaggio",
                                onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSendMessage && _ctx.onSendMessage(...args)), ["enter"]))
                              }, null, 544), [
                                [_vModelText, _ctx.message]
                              ]),
                              _createElementVNode("div", {
                                class: "attachments relative right-6 cursor-pointer rounded-full z-20 group",
                                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showAttachmentsOptionOnClick && _ctx.showAttachmentsOptionOnClick(...args)))
                              }, [
                                _createVNode(_component_font_awesome_icon, {
                                  class: "h-5 w-5 group-hover:text-primary-700",
                                  icon: ['fas', 'paperclip']
                                }),
                                (_ctx.showDropdownAttachmentSelection)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                      _createElementVNode("div", {
                                        class: "image-attachment flex items-center text-white pb-1 px-5 pt-2 rounded-t-lg bg-primary-200 hover:bg-primary-300",
                                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onSelectImage && _ctx.onSelectImage(...args)))
                                      }, [
                                        _createElementVNode("input", {
                                          class: "invisible absolute top-0",
                                          type: "file",
                                          ref: "fileInputImage",
                                          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onFileInputChange && _ctx.onFileInputChange(...args))),
                                          accept: _ctx.fileFormatsImages
                                        }, null, 40, _hoisted_35),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "h-4 w-4",
                                          icon: ['fas', 'image']
                                        }),
                                        _hoisted_36
                                      ]),
                                      _createElementVNode("div", {
                                        class: "image-attachment flex items-center text-white pt-1 px-5 pb-2 rounded-b-lg bg-primary-200 hover:bg-primary-300",
                                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onSelectFile && _ctx.onSelectFile(...args)))
                                      }, [
                                        _createElementVNode("input", {
                                          class: "invisible absolute top-0",
                                          type: "file",
                                          ref: "fileInput",
                                          onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onFileInputChange && _ctx.onFileInputChange(...args))),
                                          accept: _ctx.fileFormats
                                        }, null, 40, _hoisted_37),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "h-4 w-4",
                                          icon: ['fas', 'file']
                                        }),
                                        _hoisted_38
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ], 2)
                          ])
                        ]),
                        _createElementVNode("button", {
                          class: "send-button cursor-pointer",
                          disabled: _ctx.sendIsDisabled,
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onSendMessage && _ctx.onSendMessage(...args)))
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            class: _normalizeClass(["h-5 w-5 text-white p-3 ml-2 rounded-full", _ctx.sendIsDisabled ? 'bg-gray-600' : 'bg-primary-600 hover:bg-primary-400']),
                            icon: ['fas', 'paper-plane']
                          }, null, 8, ["class"])
                        ], 8, _hoisted_39)
                      ]))
                    : (_openBlock(), _createBlock(_component_PrimaryButton, {
                        key: 1,
                        class: "bg-primary-900 text-white",
                        onClick: _ctx.onJoinChat,
                        disabled: _ctx.isLoading
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Partecipa alla chat")
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]))
                ])
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.showDropdownAttachmentSelection)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "bg-black absolute w-screen h-screen top-0 left-0 opacity-0 z-0",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showDropdownAttachmentSelection = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.chat)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["detail col-span-1 rounded-xl relative mt-6 bg-gray-50", _ctx.showChatDetails == true ? 'opacity-100 w-full transition-all duration-100 ease-in-out origin-right' : 'w-0 opacity-0' ])
        }, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.chat.name), 1),
            _createElementVNode("div", _hoisted_42, "Creata il: " + _toDisplayString(_ctx.moment.unix(_ctx.chat.createdTs).format('DD/MM/YYYY')), 1),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chat.memberUserIds, (member) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _createVNode(_component_router_link, {
                    class: "hover:text-primary-400",
                    to: `/users/${member}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("· " + _toDisplayString(_ctx.getUserDisplayName(member)), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 256))
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}